import { render, staticRenderFns } from "./emptyTips.vue?vue&type=template&id=c7c9b494&scoped=true&"
import script from "./emptyTips.vue?vue&type=script&lang=js&"
export * from "./emptyTips.vue?vue&type=script&lang=js&"
import style0 from "./emptyTips.vue?vue&type=style&index=0&id=c7c9b494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c9b494",
  null
  
)

export default component.exports